import {IValidator} from './IValidator';

export class WallSizeValidator implements IValidator {

  private minHeight = 106.68;

  validate(wall, newSize) {
    return newSize.y >= this.minHeight;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/Validators/WallSizeValidator.ts